export default __webpack_public_path__ + "static/media/leftflower.8fd2e719.png";